var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isTagsEmpy)?_c('div',{staticClass:"thumbnails",attrs:{"id":"video-tags"}},_vm._l((_vm.sorted_tags),function(tag,index){return _c('video-tag',{key:tag.id,attrs:{"tag":tag,"count":_vm.tags.length - index}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }